import React from 'react';
import PropTypes from 'prop-types';
import { ListGroup, ListGroupItem, Panel } from 'react-bootstrap';
import ActivityGroup from './ActivityGroup.jsx';

export function countFilteredWbsActivities (wbsItem, filteredActivitiesMap, filteredActivities) {
	if (!wbsItem || !filteredActivitiesMap || !filteredActivities) {
		return 0;
	}

	let count = 0;
	const activityIds = wbsItem.activityIds || [];
	for (let i = 0; i < activityIds.length; i++) {
		const activityId = activityIds[i];
		if (activityId in filteredActivitiesMap && filteredActivitiesMap[activityId] in filteredActivities) {
			count++;
		}
	}

	const children = wbsItem.children || {};
	const childrenSequence = wbsItem.childrenSequence || [];
	for (let i = 0; i < childrenSequence.length; i++) {
		const childWbsId = childrenSequence[i];
		if (childWbsId in children) {
			count += countFilteredWbsActivities(
				children[childWbsId],
				filteredActivitiesMap,
				filteredActivities
			);
		}
	}

	return count;
}

const WBSTreeItem = ({
	wbsItem,
	filteredActivities,
	filteredActivitiesMap,
	datasetInfo
}) => {
	const { wbsName, children, childrenSequence, activityIds } = wbsItem;
	const filteredCount = countFilteredWbsActivities(
		wbsItem,
		filteredActivitiesMap,
		filteredActivities
	);

	// Hide WBS headers with no matching activities under the current filter.
	if (!filteredCount) {
		return null;
	}

	const wbsTreeItems = [];
	for (let i = 0; i < childrenSequence.length; i++) {
		const childWbsId = childrenSequence[i];
		if (!(childWbsId in children)) {
			continue;
		}
		const childWbsItem = children[childWbsId];
		const childFilteredCount = countFilteredWbsActivities(
			childWbsItem,
			filteredActivitiesMap,
			filteredActivities
		);
		if (!childFilteredCount) {
			continue;
		}
		wbsTreeItems.push(
			<ListGroupItem key={childWbsId}>
				<WBSTreeItem
					wbsItem={childWbsItem}
					filteredActivities={filteredActivities}
					filteredActivitiesMap={filteredActivitiesMap}
					datasetInfo={datasetInfo} />
			</ListGroupItem>
		);
	}
	const wbsTree = wbsTreeItems.length
		? <ListGroup className="wbsTreeItemListGroup">{wbsTreeItems}</ListGroup>
		: null;

	const activitiesForWBS = activityIds.filter(activityId => {
		return activityId in filteredActivitiesMap && filteredActivitiesMap[activityId] in filteredActivities;
	}).map(activityId => {
		return filteredActivities[filteredActivitiesMap[activityId]];
	});

	const activityGroup = (
		<ActivityGroup
			className="activityListPanel"
			activities={activitiesForWBS}
			datasetInfo={datasetInfo} />
	);

	return (
		<Panel
			defaultExpanded
			className="wbsTreeItemPanel">
			<Panel.Heading>
				<Panel.Title toggle>
					{`${wbsName} (${filteredCount})`}
				</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				{activityGroup}
				{wbsTree}
			</Panel.Collapse>
		</Panel>
	);
};

WBSTreeItem.propTypes = {
	wbsItem: PropTypes.shape({
		wbsName: PropTypes.string,
		children: PropTypes.object,
		childrenSequence: PropTypes.shape({
			length: PropTypes.string
		}),
		activityIds: PropTypes.array,
		descendantActivityCount: PropTypes.number
	}),
	filteredActivities: PropTypes.array,
	filteredActivitiesMap: PropTypes.object,
	datasetInfo: PropTypes.object
};

export default WBSTreeItem;
